import React from "react";

interface Prop {
  title: string;
  marginBottom?: number;
}

const SubTitle: React.FC<Prop> = ({ title, marginBottom = 10 }) => {
  return (
    <>
      <p
        className={`text-center text-lightBlue font-Mulish w-[80%] mx-auto sm:w-full  text-[16px] sm:text-base font-normal mb-6 sm:mb-${marginBottom}`}
      >
        {title}
      </p>
    </>
  );
};

export default SubTitle;
